import React, { FC } from 'react';

import { Box, Grid, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';

import { NormalLink } from '~components/shared/link';
import { black, primaryColors } from '~components/theme/styles/colors';

import SlideWrapper from '../SlideWrapper';

interface ArticlePreviewProps {
  title: string;
  imgSrc: string;
  description: string;
  href: string;
}

const ArticlePreview: FC<ArticlePreviewProps> = ({ title, imgSrc, description, href }) => (
  <Box sx={{ borderRadius: '8px', width: '100%', height: '100%', background: black['45%'] }}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      <Image height={200} width={240} src={imgSrc} />
    </Box>
    <Stack spacing={4} direction={'column'} minHeight={300} p={4}>
      <Typography variant={'lead'} height={48} color={primaryColors[100]}>
        {title}
      </Typography>
      <Typography height={78} variant={'body2'} color={primaryColors[100]}>
        {description}
      </Typography>
      <NormalLink href={href} target={'_blank'} sx={{ textDecoration: 'none' }}>
        <ButtonWithIcon variant={'primary'} iconType="arrow">
          READ MORE
        </ButtonWithIcon>
      </NormalLink>
    </Stack>
  </Box>
);

const ARTICLES: ArticlePreviewProps[] = [
  {
    title: 'Florida man buys all VST',
    imgSrc: '/img/carousel/carousel-vote.webp',
    description: 'Florida man single handedly restores VST peg, in a bath salts fueled crypto frenzy.',
    href: '',
  },
  {
    title: 'Florida man buys all VSTA',
    imgSrc: '/img/carousel/carousel-stake.webp',
    description: 'Florida man single handedly becomes the richest man alive in a PCP fueled spending spree.',
    href: '',
  },
  {
    title: 'Florida man dies instantly.',
    imgSrc: '/img/carousel/carousel-farm.webp',
    description: 'RIP florida man.',
    href: '',
  },
];

function StayUpdatedSlide() {
  return (
    <SlideWrapper>
      <Typography variant={'h4'} color={primaryColors[50]}>
        Stay up to date with Vesta
      </Typography>
      <Stack spacing={4} mt={12}>
        <Typography variant={'h6'} color={primaryColors[100]}>
          Our latest articles
        </Typography>
        <Grid container direction={'row'}>
          {ARTICLES.map((article, index) => (
            <Grid
              sx={index >= ARTICLES.length - 1 ? undefined : { pr: { xs: 0, sm: 4 }, pb: { xs: 4, sm: 0 } }}
              item
              xs={12}
              sm={12 / ARTICLES.length}
              key={article.title}
            >
              <ArticlePreview {...article} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </SlideWrapper>
  );
}

export default StayUpdatedSlide;
